"use client"

import { Card, CardContent, CardHeader, CardTitle } from "@workspace/web-ui/components/card"
import { differenceInMinutes } from "date-fns"
import type { CalendarEvent } from "./types"
import { EventDetails } from "./expandable-appointments"

interface AppointmentDetailsModalProps {
  data: CalendarEvent
  onClose: () => void
}

export function AppointmentDetailsModal({ data }: AppointmentDetailsModalProps) {
  const remainingTime = data?.start
    ? differenceInMinutes(new Date(data.start), new Date())
    : null;

  const remainingTimeText = remainingTime !== null
    ? remainingTime <= 0
        ? "0 minutes remaining"
        : remainingTime > 60
            ? `${Math.floor(remainingTime / 60)} hours and ${remainingTime % 60} minutes remaining`
            : `${remainingTime} minutes remaining`
    : "Invalid start time";

  return (
    <Card className="w-full bg-white border-none z-50 shadow-none">
      <CardContent className="w-full px-3">
        <CardHeader className="px-0 py-3">
          <CardTitle className="text-xl font-semibold">{data.title}</CardTitle>
        </CardHeader>

        <div className="text-sm text-muted-foreground">
          {/* Use the EventDetails component from the first file */}
          <EventDetails event={data} />
          
          {/* Add the remaining time info */}
          <div className="text-sm text-muted-foreground mt-4">
            {remainingTimeText}
          </div>
        </div>
      </CardContent>
    </Card>
  )
}